import { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class AbstractToggle extends PureComponent {
  static propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func
  };

  static defaultProps = {
    onChange: () => {}
  };

  onChange = () => {
    const { onChange, checked } = this.props;
    onChange(!checked);
  };
}
